import React from 'react'
import PropTypes from 'prop-types'
import LPCarousel from './LPCarousel'
import { TestimonialSection, Header } from './styles'

export default function LPTestimonials({ title, testimonials }) {
  return (
    <>
      <TestimonialSection>
        <Header>{title}</Header>
        <LPCarousel testimonials={testimonials} />
      </TestimonialSection>
    </>
  )
}

LPTestimonials.propTypes = {
  title: PropTypes.string,
  testimonials: PropTypes.array,
}
